// 使用 Mock
var Mock = require('mockjs')

Mock.mock(/v1\/user/, 'get', {
  'list|1-10': [{
    'id|+1': 1,
    'email': '@EMAIL'
  }]
})

